import { render, staticRenderFns } from "./classfyBreadCrumb.vue?vue&type=template&id=0f82682f&scoped=true"
import script from "./classfyBreadCrumb.vue?vue&type=script&lang=js"
export * from "./classfyBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./classfyBreadCrumb.vue?vue&type=style&index=0&id=0f82682f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82682f",
  null
  
)

export default component.exports